import { render, staticRenderFns } from "./ModalExcluirAta.vue?vue&type=template&id=6dbfb6ab&scoped=true"
import script from "./ModalExcluirAta.vue?vue&type=script&lang=js"
export * from "./ModalExcluirAta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbfb6ab",
  null
  
)

export default component.exports